module.exports = __webpack_public_path__ + "static/portfolio-mas-15-468854f9678010e2362e22367e3ee9e0.jpg";